var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOutgoingIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.951 62.031",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".outgoing_icon_svg__a,.outgoing_icon_svg__b{fill:none;stroke:inherit;stroke-width:2px}.outgoing_icon_svg__a{stroke-linecap:round;stroke-linejoin:round;fill-rule:evenodd}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "outgoing_icon_svg__a",
    d: "M36.667 61.03v-4.967a2.671 2.671 0 012.634-2.7s4.895-.221 6.161-.7c2.5-.964 2.945-2.144 3.069-4.491a43.171 43.171 0 00-.362-7.233l5.031-2.394a2.226 2.226 0 001.148-1.371 2.3 2.3 0 00-.21-1.8s-5.5-7.024-5.816-10.011a24.265 24.265 0 00-16.4-23.157 23.309 23.309 0 00-26.47 8.945 24.87 24.87 0 00.172 28.642c4.307 5.984 6.308 10.272 6.308 21.235"
  }), /*#__PURE__*/React.createElement("path", {
    className: "outgoing_icon_svg__b",
    d: "M62.951 37.103l5-3M63.951 43.49h6M62.951 50.966l5 3"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOutgoingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/outgoing_icon.1695036e0919be5ac22a92fe80f87395.svg";